export default "__VITE_ASSET__Bp_29kQI__"